import { render } from "./ui-notification.vue?vue&type=template&id=745d3b99&scoped=true"
import script from "./ui-notification.vue?vue&type=script&lang=js"
export * from "./ui-notification.vue?vue&type=script&lang=js"

import "./ui-notification.vue?vue&type=style&index=0&id=745d3b99&lang=stylus&scoped=true"

import exportComponent from "/var/www/docker/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-745d3b99"],['__file',"src/components/ui/ui-notification.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "745d3b99"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('745d3b99', __exports__)) {
    api.reload('745d3b99', __exports__)
  }
  
  module.hot.accept("./ui-notification.vue?vue&type=template&id=745d3b99&scoped=true", () => {
    api.rerender('745d3b99', render)
  })

}


export default __exports__